/**
 * The open orders for a site, for the order picker on "Receive material"
 * (PoPicker.tsx). Kept apart from the cards so they can be drawn without a
 * database. 02-11-2026.
 */
import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { RECEIVABLE, WAITING, type PickerPo } from './PoPicker'

/** Open orders for a site: receivable ones and the ones waiting for acknowledgement. */
export function useSitePos(siteId: string) {
  const [pos, setPos] = useState<PickerPo[] | null>(null)
  useEffect(() => {
    if (!siteId) { setPos([]); return }
    let live = true
    setPos(null)
    void (async () => {
      const { data } = await supabase.from('purchase_orders')
        .select('id, vendor_id, status, date_created, delivery_date, '
                + 'po_line_items(material_id, quantity_ordered, quantity_received_so_far, quantity_remaining)')
        .eq('site_id', siteId)
        .in('status', [...RECEIVABLE, ...WAITING])
        .order('date_created', { ascending: false })
      if (!live) return
      setPos(((data ?? []) as any[]).map((p) => ({
        id: p.id, vendor_id: p.vendor_id, status: p.status,
        date_created: p.date_created, delivery_date: p.delivery_date,
        lines: ((p.po_line_items ?? []) as any[]).map((l) => ({
          material_id: l.material_id,
          ordered: Number(l.quantity_ordered) || 0,
          received: Number(l.quantity_received_so_far) || 0,
          pending: Number(l.quantity_remaining) || 0,
        })),
      })).filter((p) => p.lines.some((l) => l.pending > 0.0001)))
    })()
    return () => { live = false }
  }, [siteId])
  return pos
}

